  <div class="container-fluid page-content">

    <div class="row justify-content-center align-items-center mb-1" style="width: 100%;">
      <div class="col">
        <label class="title">Reportes</label>
      </div>
      <div class="col text-end">
        @if(isReports){
          <button (click)="downloadLectorExcel()" class="btn btn-sm btn-success rounded-button">
            <i class="fas fa-file-export"></i>&nbsp;
            Excel
          </button>
          }@else{
          <button (click)="descargarExcel()" class="btn btn-sm btn-success rounded-button">
            <i class="fas fa-file-export"></i>&nbsp;
            Excel
          </button>
        }
      </div>
    </div>

    <!--Busqueda-->
    <div class="card mt-1 mb-3" style="border-radius: 12px;">
      <div class="card-body" style="padding-top: 18px; padding-bottom: 18px;">
        <form #formSearchCargas="ngForm" (ngSubmit)="buscarConParametros();">
          <div class="row justify-content-center align-items-center" style="width: 100%;">
            <div class="col col-lg-3 col-md-3 col-sm-12 col-12">
              <div class="form-group">
                <label class="mb-2"> Estaci&oacute;n </label>
                <br>
                  <p-dropdown [disabled]="!isAdmin && !isReports" name="slcEstaciones" #slcEstaciones="ngModel" [options]="estaciones" [filter]="true" filterBy="label" [style]="{'width':'100%'}" [showClear]="true" placeholder="Todas las estaciones" [(ngModel)]="searchReportsRQ.station"
                    styleClass="custom-input" optionValue="value" optionLabel="label" (onChange)="onEstacionChange()">

                  </p-dropdown>
                </div>
              </div>
              <div class="col col-lg-3 col-md-3 col-sm-12 col-12">
                <div class="form-group">
                  <label class="mb-2"> Activo </label>
                  <br>
                    <p-dropdown name="slcActivos" #slcActivos="ngModel" [options]="activosCatalog" [filter]="true" filterBy="label" [style]="{'width':'100%'}" [showClear]="true" placeholder="Todos los activos" [(ngModel)]="searchReportsRQ.activo"
                      styleClass="custom-input" optionValue="value" optionLabel="label">

                    </p-dropdown>
                  </div>
                </div>
                <div class="col col-lg-3 col-md-3 col-sm-12 col-12">
                  <div class="form-group">
                    <label class="mb-2"> Familia </label>
                    <br>
                      <p-dropdown name="slcFamilias" #slcFamilias ="ngModel" [options]="familiasCatalog" [filter]="true" filterBy="label" [style]="{'width':'100%'}" [showClear]="true" placeholder="Todas las familias" [(ngModel)]="searchReportsRQ.familia"
                        styleClass="custom-input" optionValue="value" optionLabel="label">

                      </p-dropdown>
                    </div>
                  </div>
                  <div class="col col-lg-3 col-md-3 col-sm-12 col-12">
                    <div class="form-group">
                      <label class="mb-2"> Tipo de Combustible </label>
                      <br>
                        <p-dropdown name="slcTipoCombustible" #slcTipoCombustible="ngModel" [options]="combustiblesCatalog" [filter]="true" filterBy="label" [style]="{'width':'100%'}" [showClear]="true" placeholder="Todos los tipos de combustibles" [(ngModel)]="searchReportsRQ.tipoCombustible"
                          styleClass="custom-input" optionValue="value" optionLabel="label">

                        </p-dropdown>
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-left align-items-left" style="width: 100%;">
                    <div class="col col-lg-3 col-md-3 col-sm-12 col-12">
                      <div class="form-group">
                        <label class="mb-2"> Fecha Inicio </label>
                        <br>
                          <p-calendar dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24" [readonlyInput]="true" appendTo="body" inputStyleClass="custom-input" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" name="FechaInicio" #FechaInicio="ngModel" placeholder="Desde" [(ngModel)]="searchReportsRQ.startDate" (onSelect)="setSeconds(searchReportsRQ.startDate)">
                          </p-calendar>
                        </div>
                      </div>
                      <div class="col col-lg-3 col-md-3 col-sm-12 col-12">
                        <div class="form-group">
                          <label class="mb-2"> Fecha Fin </label>
                          <br>
                            <p-calendar dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24" [readonlyInput]="true" appendTo="body" inputStyleClass="custom-input" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" name="FechaInicio" #FechaInicio="ngModel" placeholder="Hasta" [(ngModel)]="searchReportsRQ.endDate" (onSelect)="setSeconds(searchReportsRQ.endDate)">
                            </p-calendar>
                          </div>
                        </div>
                        <div class="col col-lg-3 col-md-3 col-sm-12 col-12 text-center">
                          <div class="form-group">
                            <button style="margin-top: 29px; width: 100%;" class="btn my-button-blue-outline btn-sm btn-block rounded-button">
                              <i class="fas fa-search"></i>&nbsp;Buscar
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                </div>
                @if (!showXML) {
                  <div class="row align-items-center justify-content-center" style="margin-right: 0px; margin-left: 0px;height:calc(100vh - 320px);">
                    <div class="col-lg-12 col-12 col-sm-12 col-md-12 text-center ">
                      <h3 style="text-align: center; "> Ingresar par&aacute;metros para mostrar informaci&oacute;n inicial.</h3>
                    </div>
                  </div>
                }
                @if (sinCargasXML) {
                  <div class="row align-items-center justify-content-center" style="margin-right: 0px; margin-left: 0px;height:calc(100vh - 320px);">
                    <div class="col-lg-12 col-12 col-sm-12 col-md-12 text-center ">
                      <h3> No hay informaci&oacute;n con los par&aacute;metros ingresados. </h3>
                    </div>
                  </div>
                }
                @if (rendimientoFlag) {
                  <div class="row " style="margin-right: 0px; margin-left: 0px;">
                    <div class="col-lg-12 col-sm-12 col-md-12 col-12">
                      <mat-tab-group animationDuration="0ms">
                        <mat-tab>
                          <ng-template mat-tab-label>
                            <i class="fas fa-pager" style="margin-right: 5px;"></i> Rendimiento por Equipo.
                          </ng-template>
                          <div class="mt-3"></div>
                          <p-table #dt [value]="rendimientoList" [scrollable]="true" [scrollHeight]="'calc(100vh - 360px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">
                            <ng-template pTemplate="header">
                              <tr>
                                <th pSortableColumn="activo" class="small-col" style="border-top-left-radius: 15px;"> N&uacute;mero Econ&oacute;mico</th>
                                <th pSortableColumn="combustibleCargado" class="small-col">Tipo de Combustible</th>
                                <th pSortableColumn="fechaCarga" class="medium-col"> Fecha de Carga </th>
                                <th pSortableColumn="litrosCarga" class="small-col"> LTS Consumidos </th>
                                <th pSortableColumn="horometroActual" class="small-col"> Hor&oacute;metro Actual </th>
                                <th pSortableColumn="horometroAnterior" class="small-col"> Hor&oacute;metro Anterior </th>
                                <th pSortableColumn="hrsTrabajo" class="small-col"> Horas Trabajadas </th>
                                <th pSortableColumn="rendimiento" class="small-col">Rendimiento</th>
                                <th pSortableColumn="rendimientoEquipo" style="border-top-right-radius: 15px;" class="small-col">Rendimiento por Equipo</th>
                              </tr>
                              <tr class="filter-row">
                                <th>
                                  <input placeholder="Filtrar" type="text" #filtroActivo class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroActivo.value, 'activo', 'contains')">
                                </th>
                                <th>
                                  <input placeholder="Filtrar" #filtroCombustibleCargado type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroCombustibleCargado.value, 'combustibleCargado', 'contains')">
                                </th>
                                <th>
                                  <input placeholder="Filtrar" #filtroFechaCarga type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroFechaCarga.value, 'fechaCarga', 'contains')">
                                </th>
                                <th>
                                  <input placeholder="Filtrar" #filtroLitrosCarga type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroLitrosCarga.value, 'litrosCarga', 'contains')">
                                </th>
                                <th>
                                  <input placeholder="Filtrar" #filtroHorometroActual type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroHorometroActual.value, 'horometroActual', 'contains')">
                                </th>
                                <th>
                                  <input placeholder="Filtrar" #filtroHorometroAnterior type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroHorometroAnterior.value, 'horometroAnterior', 'contains')">
                                </th>
                                <th>
                                  <input placeholder="Filtrar" #filtroHrsTrabajo type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroHrsTrabajo.value, 'hrsTrabajo', 'contains')">
                                </th>
                                <th>
                                  <input placeholder="Filtrar" #filtroRendimiento type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroRendimiento.value, 'rendimiento', 'contains')">
                                </th>
                                <th>
                                  <input placeholder="Filtrar" #filtroRendimientoEquipo type="text" class="form-input form-input-table-filter small-col" (input)="dt.filter(filtroRendimientoEquipo.value, 'rendimientoEquipo', 'contains')">
                                </th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" class="animated fadeIn fast" let-rendimiento>
                              <tr>
                                <td class="small-col">{{ rendimiento.activo }}</td>
                                <td class="small-col">{{rendimiento.combustibleCargado}}</td>
                                <td class="medium-col">{{rendimiento.fechaCarga | date: 'yyyy-MM-dd hh:mm:ss aa' }}</td>
                                <td class="small-col">{{rendimiento.litrosCarga}}</td>
                                <td class="small-col">{{rendimiento.horometroActual}}</td>
                                <td class="small-col">{{rendimiento.horometroAnterior}}</td>
                                <td class="small-col">{{rendimiento.hrsTrabajo}}</td>
                                <td class="small-col">{{rendimiento.rendimiento }}</td>
                                <td class="small-col">{{rendimiento.rendimientoEquipo }}</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </mat-tab>
                        <mat-tab>
                          <ng-template mat-tab-label>
                            <i class="fas fa-pager" style="margin-right: 5px;"></i> Rendimiento por Familia
                          </ng-template>
                          <div class="mt-3 row align-items-center justify-content-center text-center" style="margin-right: 0px; margin-left: 0px;">
                            <div class="col-lg-12 col-12 col-sm-12 col-md-12 ">
                              <p-table #dt [value]="rendimientoFamiliaList" [scrollHeight]="'calc(100vh - 260px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">
                                <ng-template pTemplate="header">
                                  <tr>
                                    <th pSortableColumn="rendimiento" style="border-top-left-radius: 15px;" class="medium-col">Familia</th>
                                    <th pSortableColumn="rendimientoEquipo" style="border-top-right-radius: 15px;" class="medium-col">Rendimiento por Familia</th>
                                  </tr>
                                  <tr class="filter-row">
                                    <th class="filter-row">
                                      <input placeholder="Filtrar" #filtroFamilia type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroFamilia.value, 'familia', 'contains')">
                                    </th>
                                    <th class="filter-row">
                                      <input placeholder="Filtrar" #filtroRendimientoFamilia type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroRendimientoFamilia.value, 'rendimiento', 'contains')">
                                    </th>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="body" class="animated fadeIn fast" let-rendimiento>
                                  <tr>
                                    <td class="medium-col">{{rendimiento.familia }}</td>
                                    <td class="medium-col">{{rendimiento.rendimiento }}</td>
                                  </tr>
                                </ng-template>
                              </p-table>
                            </div>
                          </div>
                        </mat-tab>
                      </mat-tab-group>
                    </div>
                  </div>
                }

              </div>